export default {
    en: {
        teachers: "TEACHERS",
        plan: "SCHEDULE"
    },
    zh: {
        teachers: "师资",
        plan: "日程"
    }
}